/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiCreateScenarioDto,
  ApiIncomingTransferResponse,
  ApiScenarioResponse,
  ApiSharedScenarioResponse,
  ApiTransferResponse,
  ApiUpdateCollectionItemIdDto,
  ApiUpdateScenarioDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class GtwScenario<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerFindAll
   * @summary Get list of all scenarios
   * @request GET:/gtw/scenario/scenarios
   * @secure
   * @response `200` `(ApiScenarioResponse)[]` List of scenarios successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerFindAll = (params: RequestParams = {}) =>
    this.request<ApiScenarioResponse[], ApiBaseError>({
      path: `/gtw/scenario/scenarios`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerCreate
   * @summary Create a new scenario
   * @request POST:/gtw/scenario/scenarios
   * @secure
   * @response `201` `ApiScenarioResponse`
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerCreate = (
    data: ApiCreateScenarioDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiScenarioResponse, ApiBaseError>({
      path: `/gtw/scenario/scenarios`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerFindOne
   * @summary Get a scenario by ID
   * @request GET:/gtw/scenario/scenarios/{id}
   * @secure
   * @response `200` `ApiScenarioResponse` Scenario successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerFindOne = (id: string, params: RequestParams = {}) =>
    this.request<ApiScenarioResponse, ApiBaseError>({
      path: `/gtw/scenario/scenarios/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerUpdate
   * @summary Update a scenario
   * @request PUT:/gtw/scenario/scenarios/{id}
   * @secure
   * @response `200` `ApiScenarioResponse`
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerUpdate = (
    id: string,
    data: ApiUpdateScenarioDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiScenarioResponse, ApiBaseError>({
      path: `/gtw/scenario/scenarios/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerDelete
   * @summary Delete a scenario
   * @request DELETE:/gtw/scenario/scenarios/{id}
   * @secure
   * @response `204` `void` Scenario successfully deleted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerDelete = (id: string, params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/scenario/scenarios/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerActivate
   * @summary Activate a scenario
   * @request POST:/gtw/scenario/scenarios/{id}/activate
   * @secure
   * @response `200` `ApiScenarioResponse` Scenario successfully activated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Scenario not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerActivate = (id: string, params: RequestParams = {}) =>
    this.request<ApiScenarioResponse, ApiBaseError>({
      path: `/gtw/scenario/scenarios/${id}/activate`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerCancel
   * @summary Cancel a scenario
   * @request POST:/gtw/scenario/scenarios/{id}/cancel
   * @secure
   * @response `200` `ApiScenarioResponse` Scenario successfully cancelled
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Scenario not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerCancel = (id: string, params: RequestParams = {}) =>
    this.request<ApiScenarioResponse, ApiBaseError>({
      path: `/gtw/scenario/scenarios/${id}/cancel`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerCancelAll
   * @summary Cancel all scenarios
   * @request POST:/gtw/scenario/scenarios/cancel-all
   * @secure
   * @response `200` `(ApiScenarioResponse)[]` All scenarios successfully cancelled
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerCancelAll = (params: RequestParams = {}) =>
    this.request<ApiScenarioResponse[], ApiBaseError>({
      path: `/gtw/scenario/scenarios/cancel-all`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerRevoke
   * @summary Revoke all transfers in a scenario
   * @request POST:/gtw/scenario/scenarios/{id}/revoke
   * @secure
   * @response `200` `ApiScenarioResponse` Scenario transfers successfully revoked
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Scenario not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerRevoke = (id: string, params: RequestParams = {}) =>
    this.request<ApiScenarioResponse, ApiBaseError>({
      path: `/gtw/scenario/scenarios/${id}/revoke`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerRunImmediately
   * @summary Run scenario immediately
   * @request POST:/gtw/scenario/scenarios/{id}/run
   * @secure
   * @response `200` `ApiScenarioResponse` Scenario successfully started
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Scenario not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerRunImmediately = (id: string, params: RequestParams = {}) =>
    this.request<ApiScenarioResponse, ApiBaseError>({
      path: `/gtw/scenario/scenarios/${id}/run`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerRunAll
   * @summary Run all active scenarios
   * @request POST:/gtw/scenario/scenarios/run-all
   * @secure
   * @response `200` `(ApiScenarioResponse)[]` All active scenarios successfully started
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerRunAll = (params: RequestParams = {}) =>
    this.request<ApiScenarioResponse[], ApiBaseError>({
      path: `/gtw/scenario/scenarios/run-all`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerUpdateCollectionItemId
   * @summary Update collection item ID for a scenario
   * @request PATCH:/gtw/scenario/scenarios/{id}/collection-item
   * @secure
   * @response `204` `void` Collection item ID successfully updated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Scenario not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerUpdateCollectionItemId = (
    id: string,
    data: ApiUpdateCollectionItemIdDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/scenario/scenarios/${id}/collection-item`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scenarios
   * @name ScenarioControllerFindShared
   * @summary Get list of shared scenarios
   * @request GET:/gtw/scenario/scenarios/shared
   * @secure
   * @response `200` `(ApiSharedScenarioResponse)[]` List of shared scenarios successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scenarioControllerFindShared = (params: RequestParams = {}) =>
    this.request<ApiSharedScenarioResponse[], ApiBaseError>({
      path: `/gtw/scenario/scenarios/shared`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Transfers
   * @name TransferControllerGetIncoming
   * @summary Get incoming transfers
   * @request GET:/gtw/scenario/transfers/incoming
   * @secure
   * @response `200` `(ApiIncomingTransferResponse)[]` List of incoming transfers successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  transferControllerGetIncoming = (params: RequestParams = {}) =>
    this.request<ApiIncomingTransferResponse[], ApiBaseError>({
      path: `/gtw/scenario/transfers/incoming`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Transfers
   * @name TransferControllerAccept
   * @summary Accept transfer
   * @request POST:/gtw/scenario/transfers/{id}/accept
   * @secure
   * @response `200` `ApiTransferResponse` Transfer successfully accepted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  transferControllerAccept = (id: string, params: RequestParams = {}) =>
    this.request<ApiTransferResponse, ApiBaseError>({
      path: `/gtw/scenario/transfers/${id}/accept`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Transfers
   * @name TransferControllerAcceptAll
   * @summary Accept all incoming transfers
   * @request POST:/gtw/scenario/transfers/accept-all
   * @secure
   * @response `200` `(ApiTransferResponse)[]` All incoming transfers successfully accepted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  transferControllerAcceptAll = (params: RequestParams = {}) =>
    this.request<ApiTransferResponse[], ApiBaseError>({
      path: `/gtw/scenario/transfers/accept-all`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Transfers
   * @name TransferControllerRevoke
   * @summary Revoke transfer
   * @request POST:/gtw/scenario/transfers/{id}/revoke
   * @secure
   * @response `200` `ApiTransferResponse` Transfer successfully revoked
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Transfer not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  transferControllerRevoke = (id: string, params: RequestParams = {}) =>
    this.request<ApiTransferResponse, ApiBaseError>({
      path: `/gtw/scenario/transfers/${id}/revoke`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Transfers
   * @name TransferControllerTransfer
   * @summary Transfer items
   * @request POST:/gtw/scenario/transfers/{id}/transfer
   * @secure
   * @response `200` `ApiTransferResponse` Transfer successfully executed
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Transfer not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  transferControllerTransfer = (id: string, params: RequestParams = {}) =>
    this.request<ApiTransferResponse, ApiBaseError>({
      path: `/gtw/scenario/transfers/${id}/transfer`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Transfers
   * @name TransferControllerTestTransfer
   * @summary Test transfer (for test transfers only)
   * @request POST:/gtw/scenario/transfers/{id}/test
   * @secure
   * @response `200` `ApiTransferResponse` Test transfer successfully executed
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Transfer not found
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  transferControllerTestTransfer = (id: string, params: RequestParams = {}) =>
    this.request<ApiTransferResponse, ApiBaseError>({
      path: `/gtw/scenario/transfers/${id}/test`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
}
